import { takeEvery } from 'redux-saga'
import { call, put } from 'redux-saga/effects'
import fetcher from 'modules/fetcher'
import buildErrors from 'modules/buildErrors'

import {
  calendarEntryStatusCreate,
  calendarEntryStatusCreateFailure,
  calendarEntryStatusUpdate,
  calendarEntryStatusUpdateFailure,
  calendarEntryStatusDelete,
  calendarEntryStatusDeleteFailure
} from '../actions'

import { notify } from 'utils/notify'
import {
  CALENDAR_ENTRY_STATUS_CREATE_SUBMIT,
  CALENDAR_ENTRY_STATUS_UPDATE_SUBMIT,
  CALENDAR_ENTRY_STATUS_DELETE_SUBMIT
} from '../constants'

export function * calendarEntryStatusCreateSaga ({ payload }) {
  try {
    const response = yield call(
      fetcher,
      'api/v3/admin/calendar_entry_statuses',
      {
        method: 'POST',
        body: JSON.stringify({
          calendar_entry_status: {
            name: payload.name,
            hex_color: payload.hexColor
          }
        })
      }
    )
    yield put(calendarEntryStatusCreate(response))

    // Show success message
    notify('Status created successfully', { type: 'success' })
  } catch (exception) {
    console.error(exception.message)
    yield put(calendarEntryStatusCreateFailure(buildErrors(exception?.json)))

    // Show error message
    notify('Failed to create status', { type: 'error' })
  }
}

export function * watchCalendarEntryStatusCreateSaga () {
  yield call(takeEvery, CALENDAR_ENTRY_STATUS_CREATE_SUBMIT, calendarEntryStatusCreateSaga)
}

export function * calendarEntryStatusUpdateSaga ({ payload }) {
  try {
    const response = yield call(
      fetcher,
      `api/v3/admin/calendar_entry_statuses/${payload.id}`,
      {
        method: 'PUT',
        body: JSON.stringify({
          calendar_entry_status: {
            name: payload.name,
            hex_color: payload.hexColor
          }
        })
      }
    )
    yield put(calendarEntryStatusUpdate(response))

    // Show success message
    notify('Status updated successfully', { type: 'success' })
  } catch (exception) {
    yield put(calendarEntryStatusUpdateFailure(buildErrors(exception?.json)))

    // Show error message
    notify('Failed to update status', { type: 'error' })
  }
}

export function * watchCalendarEntryStatusUpdateSaga () {
  yield call(takeEvery, CALENDAR_ENTRY_STATUS_UPDATE_SUBMIT, calendarEntryStatusUpdateSaga)
}

export function * calendarEntryStatusDeleteSaga ({ payload }) {
  try {
    const body = payload.merge_into_calendar_entry_status_id
      ? { merge_into_calendar_entry_status_id: payload.merge_into_calendar_entry_status_id }
      : {}

    yield call(
      fetcher,
      `api/v3/admin/calendar_entry_statuses/${payload.id}`,
      {
        method: 'DELETE',
        body: JSON.stringify(body)
      }
    )
    yield put(calendarEntryStatusDelete(payload))

    // Show success message
    notify('Status deleted successfully', { type: 'success' })
  } catch (exception) {
    yield put(calendarEntryStatusDeleteFailure(exception.message))

    // Show error message
    notify('Failed to delete status', { type: 'error' })
  }
}

export function * watchCalendarEntryStatusDeleteSaga () {
  yield call(takeEvery, CALENDAR_ENTRY_STATUS_DELETE_SUBMIT, calendarEntryStatusDeleteSaga)
}
